import { render } from "./index.vue?vue&type=template&id=2b46781e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2b46781e&scoped=true&lang=scss"

import exportComponent from "/root/workspace/adx-frontend_wteR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b46781e"]])

export default __exports__